module.exports = __webpack_public_path__ + "static/media/5-b.b6a27f4f.jpg";